module.exports = __webpack_public_path__ + "img/leagal.ce095a99.svg";